import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, Avatar, Chip, ListItem, ListItemIcon, ListItemText, Typography, Theme } from '@material-ui/core';

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import * as actionTypes from '../../../../../Redux/Action/BackboneAction'
import { RootReduxState } from '../../../../../Redux/Store';
import PagePath from '../../../../../Route/PagePath';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    menuIcon: {
        fontSize: '1.1rem'
    },
    listIcon: {
        minWidth: '18px',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    listCustomIcon: {

    },
    listCustomIconSub: {
        width: '6px',
        height: '6px'
    },
    listCustomIconSubActive: {
        width: '8px',
        height: '8px'
    },
    listItem: {
        marginBottom: '5px',
        alignItems: 'center'
    },
    listItemNoBack: {
        marginBottom: '5px',
        backgroundColor: 'transparent !important',
        paddingTop: '8px',
        paddingBottom: '8px',
        alignItems: 'flex-start'
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    }
}));
interface NavItemProps {
    item: PagePath
    level: number
}
const NavItem = (props: NavItemProps) => {
    const classes = useStyles();
    const location = useLocation();
    const matchesSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
    const customization = useSelector((state: RootReduxState) => state.customization);
    const dispatch = useDispatch();
    const { item, level } = props;

    const isSelected = customization.isOpen === item.label || (Boolean(item.to) && location.pathname === item.to);

    const Icon = item.icon;
    const itemIcon = Icon ? (
        <Icon stroke={1.5} size="1.3rem" className={classes.listCustomIcon} />
    ) : (
        <FiberManualRecordIcon
            className={isSelected ? classes.listCustomIconSubActive : classes.listCustomIconSub}
            fontSize='inherit'
        />
    );

    let itemIconClass = !item.icon ? classes.listIcon : classes.menuIcon;
    itemIconClass = customization.navType === 'nav-dark' ? [itemIconClass, classes.listCustomIcon].join(' ') : itemIconClass;

    let itemTarget = '';
    // if (item.IsExternalLink) {
    //     itemTarget = '_blank';
    // }

    let listItemProps = { component: Link, to: item.to, target: itemTarget };
    // if (item.IsExternalLink) {
    //     // @ts-ignore: Unreachable code error
    //     listItemProps = { component: 'a', href: item.to, target: itemTarget };
    // }

    const itemHandler = (id: string) => {
        dispatch({ type: actionTypes.MENU_OPEN, Data: id });
        matchesSM && dispatch({ type: actionTypes.SET_MENU, Data: false });
    };

    return (
        <ListItem
            key={item.label}
            disabled={item.IsDisabled}
            className={level > 1 ? classes.listItemNoBack : classes.listItem}

            selected={isSelected}
            onClick={() => itemHandler(item.label)}
            button
            style={{ paddingLeft: level * 23 + 'px', borderRadius: customization.borderRadius + 'px' }}
            {...listItemProps}
        >
            <ListItemIcon className={itemIconClass}>{itemIcon}</ListItemIcon>
            <ListItemText
                primary={
                    <Typography variant={isSelected ? 'h5' : 'body1'} color="inherit">
                        <FormattedMessage id={item.LocalePath} defaultMessage={item.label} />
                    </Typography>
                }
                secondary={
                    item.description && (
                        <Typography variant="caption" className={classes.subMenuCaption} display="block" gutterBottom>
                            <FormattedMessage id={item.description} defaultMessage={item.description} />
                        </Typography>
                    )
                }
            />
            {item.chip && (
                <Chip
                    color={item.chip.color}
                    variant={item.chip.variant}
                    size={item.chip.size}
                    label={item.chip.label}
                    avatar={item.chip.avatar ? <Avatar>{item.chip.avatar}</Avatar> : undefined}
                />
            )}
        </ListItem>
    );
};

export default NavItem;
